import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { latestNews } from '@/mocks/home';
import useScrollReveal from '@/hooks/useScrollReveal';

export default function NewsSection() {
  const { t } = useTranslation();
  const revealRef = useScrollReveal();

  return (
    <section ref={revealRef} className="reveal max-w-[1200px] mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          {t('section.news')}
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {latestNews.map((news) => (
          <Link
            key={news.id}
            to={`/article/${news.id}`}
            className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-background-300 transition-all duration-300"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={news.image}
                alt={news.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                <span>{news.date}</span>
                <span>·</span>
                <span>{news.author}</span>
                <span>·</span>
                <span>{news.views.toLocaleString()} 阅读</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {news.title}
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2">
                {news.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}